export default __webpack_public_path__ + "static/media/4_thumbnail.8867da93.JPG";